import React, { useState, useEffect } from 'react'
import InputMask from 'react-input-mask'
import api from '../../components/api'

import { useEnergiaAquecimentoContext } from '../../context/energiaAquecimentoContext'
import { useTabelaGestao } from '../../context/GestaoPendenciasContext'

import Table from 'react-bootstrap/Table'



import { Link } from 'react-router-dom'
import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../StatusValidacaoSecao'


const Aquecimento = (props) => {


    var ano = props.ano
    var energia_id = props.energia_id

    const { atualizacaoGestao } = useTabelaGestao()

    const { energiaAquecimento_id, setEnergiaAquecimento_id } = useEnergiaAquecimentoContext()

    const [resultadoAquecimento, setResultadoAquecimento] = useState()
    

    const [informa, setInforma] = useState(true)


    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()




    const [questao1, setQuestao1] = useState()
    const [totalPendencias, setTotalPendencias] = useState(0)


    useEffect(() => {

        verificaValidacoes()

    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao1()
        
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'Aquecimento':

                                totalErros = totalErros + 1
                                setQuestao1('red')
    
                            break


                            
                        }

                    }

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    function consultaAquecimento() {


        api.get(`energiaAquecimentoListaTodos/${energia_id}`).then((result) => {

            //console.log(result.data)
            setResultadoAquecimento(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalEnergiaAquecimento').modal('show');setEnergiaAquecimento_id(rs.energiaAquecimento_id)}}>
                    <td>
                        {rs.tipo}
                    </td>
                    <td>
                        {rs.marca}
                    </td>
                    <td>
                        {rs.quantidade}
                    </td>
                    <td>
                        {rs.identificacao}
                    </td>
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }





    const consultaInforma = () => {

        api.get(`energiaInforma/${energia_id}/informaAquecimento`).then((result) => {

            //console.log(result.data)
            setInforma(result.data[0].informaAquecimento)

        }).catch((err) => {

            console.log(err.response)

        })
    }


    


    useEffect(() => {

        var dataPost = {

            tipo: 'informaAquecimento',
            informa: informa,

        }

        api.post(`energiaInforma/${energia_id}`, dataPost).then((result) => {

            console.log(result.data)

        }).catch((err) => {

            console.log(err.response)

        })

    }, [informa])

    

    useEffect(() => {

        consultaAquecimento()
        consultaInforma()
        
    }, [ano, energia_id, atualizacaoGestao])





    return (
        <div>

            

            <div className="col-md-12" >
                <div align="left">

                
                    <select className="form-control" value={informa} onChange={event => setInforma(event.target.value)}>
                        <option value={true}>A instituição possui o(s) equipamento(s) e reportará suas informações</option>
                        <option value={false}>A instituição não possui o(s) equipamento(s) ou a instituição possui o(s) equipamento(s) mas não reportará suas informações</option>
                    </select>
                    <br/>

                </div>
            </div>



            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>
                <div align="left">


                    
                    <Link to='#' style={{ color: questao1 }} onClick={() => {setEnunciado('Aquecimento');setSecaoEnunciado('Aquecimento');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade]</Link>
                    <br/><br/>
                    
                    
                    <button type="button" className="btn btn-warning" onClick={() => {window.$('#modalEnergiaAquecimento').modal('show');setEnergiaAquecimento_id()}}  >+ Adicionar</button>
                    <br/><br/>

                </div>
            </div>

            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>


                <Table striped bordered hover>

                    <thead>
                        
                        <tr>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Tipo

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Marca

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Quantidade

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Ambiente

                            </th>
                           

                        </tr>
                    </thead>
                    <tbody>
                        {resultadoAquecimento}
                    </tbody>

                </Table>

            </div>


            <StatusValidacaoSecao desafio="Energia" secaoCampo="secaoAquecimento" totalPendencias={totalPendencias} nomeDesafio="Desafio Energia" formulario_id={energia_id} secao="Aquecimento" ano={ano} />

        </div>
    )


}

export default Aquecimento